import { parseToken } from './parseToken';

export function isTokenExpiringSoon(token?: string): boolean {
  if (!token) {
    return false;
  }

  const jwtToken = parseToken(token);
  if (!jwtToken) {
    return false;
  }

  const { exp, iat } = jwtToken;

  // Verification of JWT in the middle of its validity period between
  // the date of issue and the expiration date
  return (exp - iat) / 2 + iat <= Date.now() / 1000;
}
